var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SubmenuNav',{attrs:{"submenus":_vm.submenus,"generate-url":_vm.generateSubmenuPath}})}
var staticRenderFns = []

export { render, staticRenderFns }